<template>
  <div class="">
    <topbar :showBack="index > 0" @back="index -= 1" :progressIndex="index" :progressMax="quiz.questions.length" color="purple" />
    <div class="p-3 w-full max-w-6xl mx-auto">
      <div class="text-secondary_text">{{title}}</div>
      <div>{{questionText}}</div>

      <div class="flex flex-col">
        <check-button v-for="(answer, i) in answers" :key="answer.text" :value="localAnswers[index] == i" @input="sendAnswer(i)">{{answer.text}}</check-button>
      </div>

      <div class="flex justify-center">
        <div class="rounded-full border border-quiz-1 text-quiz-1 font-bold bg-white flex justify-center items-center w-16 h-16 m-4">{{time}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckButton from '@/components/CheckButton'
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      index: 0,
      startTime: Date.now(),
      now: Date.now(),
      localAnswers: {}
    }
  },
  props: {
    quiz: Object,
    unanswered: Number,
  },
  components: {
    CheckButton: CheckButton
  },
  mounted() {
    setInterval(() => {
      this.now = Date.now()
    }, 1000);
  },
  computed: {
    currentQuestion() {
      return this.quiz.questions[this.index]
    },
    questionText() {
      return this.currentQuestion.question
    },
    title() {
      return this.currentQuestion.title
    },
    answers() {
      return this.currentQuestion.answers
    },
    time() {
      const d = (this.now - this.startTime)/1000
      const m = Math.floor(d / 60)
      const s = Math.floor(d % 60)

      return m + ':' + ((s < 10) ? `0${s}` : s)
    },
  },
  methods: {
    ...mapActions('quiz', ['persistAnswers', 'setAnswer']),

    sendAnswer(i) {
      this.$set(this.localAnswers, this.index, i)
      this.setAnswer({
        id: this.quiz.id,
        question: this.index,
        answer: i
      })
      if(this.index + 1 < this.quiz.questions.length) {
        setTimeout(() => {
          this.index += 1
        }, 500);
      } else {
        this.persistAnswers({id: this.quiz.id})
          .then(() => this.$emit('finished'))
      }
    }
  }
}
</script>

<style>

</style>